import {
  createAlarm,
  CreateAlarmMutation,
  CreateAlarmMutationVariables,
  DeleteAlarmMutationVariables,
  graphqlCall,
} from '@akin-home/amplify';
import { API } from 'aws-amplify';
import { UpdateAlarmInput } from '../types';

export const createAlarmMutation = (params: CreateAlarmMutationVariables) =>
  graphqlCall<CreateAlarmMutation>(createAlarm, params);

export const updateAlarmMutation = (params: { input: UpdateAlarmInput }) =>
  API.put('CalendarAPI', `/alarms/${params.input?.id}`.replace('#', '%23'), {
    body: { input: params.input },
  });

export const deleteAlarmMutation = (params: DeleteAlarmMutationVariables) =>
  API.del('CalendarAPI', `/alarms/${params.input?.id}`.replace('#', '%23'), {});
